import { sha256 } from '@noble/hashes/sha256';
import { ripemd160 } from '@noble/hashes/ripemd160';

export function bitcoinAddress(pubUncompressed: Uint8Array): string {
  const compressed = compressPubKey(pubUncompressed);
  const hash160 = ripemd160(sha256(compressed));
  return bech32Encode('bc', 0, hash160);
}

function compressPubKey(pub: Uint8Array): Uint8Array {
  if (pub.length !== 65 || pub[0] !== 0x04) return pub;
  const out = new Uint8Array(33);
  out[0] = (pub[64] & 1) === 0 ? 0x02 : 0x03;
  out.set(pub.slice(1, 33), 1);
  return out;
}

const CHARSET = 'qpzry9x8gf2tvdw0s3jn54khce6mua7l';

function bech32Encode(hrp: string, witnessVersion: number, data: Uint8Array): string {
  const converted = convertBits(data, 8, 5, true);
  const values = new Uint8Array([witnessVersion, ...converted]);
  const checksum = bech32Checksum(hrp, values);
  const combined = new Uint8Array([...values, ...checksum]);

  let result = hrp + '1';
  for (const v of combined) result += CHARSET[v];
  return result;
}

function bech32Checksum(hrp: string, data: Uint8Array): Uint8Array {
  const values = new Uint8Array([...hrpExpand(hrp), ...data, 0, 0, 0, 0, 0, 0]);
  const polymod = bech32Polymod(values) ^ 1;
  const out = new Uint8Array(6);
  for (let i = 0; i < 6; i++) out[i] = (polymod >> (5 * (5 - i))) & 31;
  return out;
}

function hrpExpand(hrp: string): Uint8Array {
  const out = new Uint8Array(hrp.length * 2 + 1);
  for (let i = 0; i < hrp.length; i++) out[i] = hrp.charCodeAt(i) >> 5;
  out[hrp.length] = 0;
  for (let i = 0; i < hrp.length; i++) out[hrp.length + 1 + i] = hrp.charCodeAt(i) & 31;
  return out;
}

function bech32Polymod(values: Uint8Array): number {
  const gen = [0x3b6a57b2, 0x26508e6d, 0x1ea119fa, 0x3d4233dd, 0x2a1462b3];
  let chk = 1;
  for (const v of values) {
    const b = chk >>> 25;
    chk = ((chk & 0x1ffffff) << 5) ^ v;
    for (let i = 0; i < 5; i++) {
      if ((b >> i) & 1) chk ^= gen[i];
    }
  }
  return chk;
}

function convertBits(data: Uint8Array, fromBits: number, toBits: number, pad: boolean): Uint8Array {
  let acc = 0;
  let bits = 0;
  const maxV = (1 << toBits) - 1;
  const result: number[] = [];
  for (const b of data) {
    acc = (acc << fromBits) | b;
    bits += fromBits;
    while (bits >= toBits) {
      bits -= toBits;
      result.push((acc >> bits) & maxV);
    }
  }
  if (pad && bits > 0) {
    result.push((acc << (toBits - bits)) & maxV);
  }
  return new Uint8Array(result);
}
